import { render, staticRenderFns } from "./TechInfoDropdown.vue?vue&type=template&id=06e4dd62&"
import script from "./TechInfoDropdown.vue?vue&type=script&lang=js&"
export * from "./TechInfoDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports